// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__qez4w","errorLogs":"EditorFooter_errorLogs__202Mh"};